import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SignupParams } from '@ftr/routing-paths'
import { RedirectSitePortalToHomeIfPublicNavigationGuard } from '../../guards'
import { LoggedInGuard } from '../../guards/logged-in-guard/logged-in.guard'
import { SignupModule } from '../../lib/signup/signup.module'
import { ConfirmationSentPage } from './confirmation-sent.page'
import { SignupPage } from './signup.page'

@NgModule({
  imports: [
    SignupModule,
    RouterModule.forChild([
      {
        path: 'signup',
        component: SignupPage,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        canActivate: [LoggedInGuard],
        data: {
          title: 'Create an account',
          hideSideNav: true,
        },
      },
      {
        path: 'confirmation-sent',
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        canActivate: [LoggedInGuard],
        component: ConfirmationSentPage,
        data: {
          title: 'Confirmation Email Sent',
          hideSideNav: true,
        },
      },
      {
        // We've move the verification (create password) into a lazy-loaded
        // submodule to bundle split the large password strength verifier dictionary
        path: `verification/:${SignupParams.Username}`,
        canMatch: [RedirectSitePortalToHomeIfPublicNavigationGuard],
        loadChildren: () => import('./confirmation/confirmation.module').then(m => m.ConfirmationModule),
      },
    ]),
  ],
  declarations: [SignupPage, ConfirmationSentPage],
  exports: [RouterModule],
})
export class SignupPagesModule {}
